module.exports = __webpack_public_path__ + "static/media/longSocks.a98bebe1.jpg";